<div class="invite-container">
  <form [formGroup]="form" *ngIf="!isPageShare">
    <div class="invite-header">
      <ion-img src="assets/images/logos/gospread.png" class="invite-header__logo"></ion-img>
      <h2 class="invite-header__title">Invite Friends</h2>
    </div>
    <p class="invite-description">
      Recommend the app's services to a customer who does not have the app, but would
      like to have access to the platform's benefits. Generate a personalized access link for them.
    </p>
    <div class="invite-form">
      <input class="input-default" placeholder="Client's name" formControlName="nomeCliente">
      <input class="input-default" placeholder="Client's phone number" type="number" formControlName="celular">
      <select class="input-default" formControlName="TipoLinkIndicacao" (change)="check()">
        <option value="" disabled>Type Indication</option>
        <option [value]="typeIndication.CORRIDA">TRIP</option>
        <option [value]="typeIndication.RESERVA_RESTAURANTE">RESERVATION</option>
      </select>
      <button [disabled]="form.invalid" class="button-bigger" (click)="submitForm()">
        SPREAD IT
      </button>
    </div>
  </form>
  <div *ngIf="isPageShare" class="invite-success">
    <ion-img src="assets/images/logos/gospread.png" class="invite-header__logo"></ion-img>
    <ion-icon slot="start" name="checkmark-circle" class="invite-success__icon"></ion-icon>
    <h2 class="invite-success__title">All right!</h2>
    <p class="invite-success__subtitle">The sharing link is:</p>
    <p class="invite-success__link">{{ linkShare }}</p>
    <ion-button class="ion-margin-top" color="success" expand="full" (click)="shareLink()" *ngIf="!isPwa"
      shape="round">Spread It
    </ion-button>
    <button class="button-outline ion-margin-top" (click)="copyLink()">COPY LINK</button>
  </div>
</div>
